import { templateKey, title, body, headImage } from './fields'

const vocalFields = [templateKey, headImage, title, body]
export const vocalEN = {
    file: "src/pages/vocalcoach/index.en.md",
    label: "Vocalcoach English",
    name: "vocalcoach english",
    fields: vocalFields
}

export const vocalDE = {
    file: "src/pages/vocalcoach/index.de.md",
    label: "Vocalcoach German",
    name: "vocalcoach german",
    fields: vocalFields
}
